import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export function noOlderThanValidator(maxAgeYears: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const inputDate = new Date(control.value);
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);

    const cutoff = new Date(
      today.getFullYear() - maxAgeYears,
      today.getMonth(),
      today.getDate(),
    );

    if (inputDate <= cutoff) {
      return { olderThan: 'Older than ' + maxAgeYears + ' years' };
    }

    return null;
  };
}
